import { render, staticRenderFns } from "./ClassToken.vue?vue&type=template&id=70f0c598"
import script from "./ClassToken.vue?vue&type=script&lang=js"
export * from "./ClassToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports